export default __webpack_public_path__ + "static/hitech-blockchain-edu-f8d3ead6fbc5b94220e44a66089a39ac.png";